// extracted by mini-css-extract-plugin
module.exports = {"category":"multiple-selector_category__3oKs7","indent":"multiple-selector_indent__1VXlq"};